import { Checkbox } from 'aui';
import type { MdComponentIndexProps } from '../type';
import styles from './list.module.less';

function MarkdownListItem(
  props: React.PropsWithChildren<
    {
      ordered?: boolean;
      index?: number;
      checked?: boolean | null;
    } & MdComponentIndexProps
  >,
) {
  const tag = props.ordered ? (
    <div className={styles.index}>{props.index}.</div>
  ) : (
    <div className={styles.unOrderContainer}>
      <div className={styles.dash} />
    </div>
  );
  const checkbox =
    props.checked != undefined ? (
      <Checkbox className={styles.checkbox} checked={!!props.checked} />
    ) : null;
  return (
    <div
      data-type="list-item"
      data-index={props.index}
      data-orderer={props.ordered}
      data-checked={props.checked}
      className="markdown-child-root flex"
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      {tag}
      {checkbox}
      <div className="markdown-child-root">{props.children}</div>
    </div>
  );
}

MarkdownListItem.displayName = 'MarkdownListItem';

export default MarkdownListItem;
